// Libs
import ApexChart from "react-apexcharts";
import { ApexOptions } from "apexcharts";
// Types
import { ChartSetTwo } from "../Libs/Types/ChartTypes";
// Utils
import {
  CHART_AXIS_FALLBACK,
  chartColors,
  chartHeight,
  humanize,
} from "../Libs/Utils/utils";
// UI-Components
import ChartFallBack from "../UI-Components/ChartFallback";

export default function BoxChart({
  chartData,
  dataKey,
}: {
  chartData: ChartSetTwo["BoxChart"];
  dataKey: string;
}) {
  const option: ApexOptions = {
    chart: {
      fontFamily: "Poppins",
      toolbar: {
        show: true,
      },
    },
    dataLabels: {
      style: {
        fontSize: "8px",
      },
    },
    legend: {
      show: false,
    },
    plotOptions: {
      boxPlot: {
        colors: {
          upper: chartColors,
          lower: chartColors,
        },
      },
    },
    fill: {
      colors: chartColors,
    },
    colors: chartColors,
    title: {
      style: { fontSize: "14px", fontWeight: "900" },
      text:
        chartData !== undefined
          ? chartData["title"]
          : CHART_AXIS_FALLBACK["title"],
      align: "left",
    },
    xaxis: {
      labels: {
        style: {
          fontSize: "8px",
        },
      },
      type: "category",
    },
    tooltip: {
      y: {
        title: {
          formatter: function (seriesName) {
            return humanize(seriesName);
          },
        },
      },
    },
    yaxis: {
      labels: {
        style: {
          fontSize: "8px",
        },
      },
    },
  };

  let data = {
    strokeWidth: 0,
    strokeHeight: 13,
    strokeLineCap: "round",
    strokeColor: chartColors,
  };
  let finalData;
  finalData = chartData["data"]?.map((value) => {
    let returnVal: any = {};
    let tempDataVal: any = {};
    returnVal["data"] = value["data"]?.map((dataValue) => {
      tempDataVal["goals"] = dataValue["goals"].map((secVal) => {
        return { ...secVal, ...data };
      });
      tempDataVal = { ...dataValue, ...tempDataVal };
      return tempDataVal;
    });
    return returnVal;
  });

  const series: any = chartData !== undefined ? finalData : undefined;

  return (
    <div className="my-2 chartWrp border-1 rounded-lg w-full p-2">
      {series !== undefined ? (
        <ApexChart
          type="boxPlot"
          options={option}
          series={series}
          height={chartHeight}
          width={"100%"}
          key={dataKey}
        />
      ) : (
        <ChartFallBack />
      )}
    </div>
  );
}
